module.exports = __webpack_public_path__ + "static/media/icon_delete_active.939df79e.svg";